import { render, staticRenderFns } from "./CustomerAttachments.vue?vue&type=template&id=5a546244&scoped=true"
import script from "./CustomerAttachments.vue?vue&type=script&lang=js"
export * from "./CustomerAttachments.vue?vue&type=script&lang=js"
import style0 from "./CustomerAttachments.vue?vue&type=style&index=0&id=5a546244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a546244",
  null
  
)

export default component.exports